import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useSearchDriver = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [fetchedDriverData, setFetchedDriverData] = useState<any[]>([]);

    const onSearchDriverError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ??
            'Something went wrong while searching for the driver.',
        );
    };

    const onSearchDriverSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<SearchDriverDataResponse>) => {
        // toast.success('Driver search completed successfully.');
        setFetchedDriverData(data?.records || []);
    };

    const searchDriver = (searchDriver: string, isAssigned = true) => {
        const urlString = `api/v1/company/search-drivers?isAssigned=${isAssigned}&page=0&size=50${searchDriver ? `&search=${searchDriver}` : ''}`;
        const url: HttpConfig = {
            url: urlString,
            // url: `api/v1/company/search-drivers?query=${searchDriver}`,
            method: 'get',
            // data: {},
        };
        request(url, onSearchDriverSuccess, setLoading, onSearchDriverError);
    };

    return { searchDriver, loading, fetchedDriverData };
};

export default useSearchDriver;


interface SearchDriverResponse {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    profilePictureUrl: string;

}

interface SearchDriverDataResponse {
    records: SearchDriverResponse[];
    totalRecords: number;
    totalPages: number;
}
